<template>
  <v-btn type="submit" color="success" class="w-100 w-sm-auto">
    <slot />
  </v-btn>
</template>
